module.exports = __webpack_public_path__ + "img/3gp.8c6d24f3.png";